import { Button, Divider, Input, notification, Popconfirm, Table } from "antd";
import React, { useEffect, useState } from "react";
import VehicleServices from "../../../../services/vehicle.services";
import catchErrorFunction from "../../../../utils/tms-catch-error/tms-catch-error";
import TmsImageUpload from "../../../../components/tms-customs/tms-image-upload";
import { DeleteOutlined } from "@ant-design/icons";
const SmDepartments = ({ router }) => {
  const [name, setName] = useState("");
  const [fileList, setFileList] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(15);
  const [tableTotalSize, setTabelTotalSize] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [editFlag, setEditFlag] = useState(false);
  const [editData, setEditData] = useState();
  const [updateFlag, setUpdateFlag] = useState(0);

  useEffect(() => {
    if (editData) {
      setName(editData.departmentName);
      setFileList([{ url: editData.signatureUrl, status: "done" }]);
    }
  }, [editData]);

  const handleCancel = () => {
    setName("");
    setSubmitLoading(false);
    setFileList([]);
    setEditData();
    setEditFlag(false);
  };
  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
  };

  const handleSubmit = async () => {
    setSubmitLoading(true);
    try {
      const body = {
        departmentName: name,
        signatureUrl: fileList[0]?.url,
      };
      if (editFlag) {
        setSubmitLoading(false);
        return;
        // await VehicleServices.updateDepartmentById(editData.id, body);
      } else {
        await VehicleServices.createDepartments(body);
      }
      handleCancel();
      fetchDepartments();
    } catch (error) {
      catchErrorFunction(error, "Failed to create walker tag serials", router);
    } finally {
      setSubmitLoading(false);
    }
  };

  const fetchDepartments = async () => {
    setLoading(true);
    try {
      const response = await VehicleServices.getDepartments();
      setTableData(response);
      setTabelTotalSize(response.total);
      setLoading(false);
    } catch (error) {
      catchErrorFunction(error, "Failed to fetch access gates", router);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, [updateFlag]);

  const columns = [
    {
      title: "Name",
      dataIndex: "departmentName",
      key: "departmentName",
    },
    {
      title: "URL",
      dataIndex: "signatureUrl",
      key: "signatureUrl",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <>
          <a
            type="primary"
            onClick={() => {
              setEditData(record);
              setEditFlag(true);
            }}
          >
            Edit
          </a>
          <Divider type="vertical" />
          <Popconfirm
            title="Are you sure delete this department?"
            onConfirm={async () => {
              setLoading(true);
              try {
                await VehicleServices.deleteDepartment(record?.id);
                notification.success({
                  message: "Department Deleted Successful",
                });
                setUpdateFlag(Math.Random + 1);
              } catch (error) {
                catchErrorFunction(
                  error,
                  "Token Expired, redirecting to login page in 5 seconds",
                  router
                );
              }
              setLoading(false);
            }}
            okText="Yes"
            cancelText="No"
          >
            <a>
              <DeleteOutlined />
            </a>
          </Popconfirm>{" "}
        </>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          <label style={{ textAlign: "left" }}>Name</label>
          <Input
            placeholder="Name"
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          {" "}
          <label style={{ textAlign: "left" }}>Upload Signature</label>
          <TmsImageUpload
            fileList={fileList}
            setFileList={setFileList}
            router={router}
            type="private"
            accept={true}
            className="w-100"
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "start",
            gap: "10px",
            paddingTop: "22px",
          }}
        >
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" onClick={handleSubmit} loading={submitLoading}>
            {editFlag ? "Update" : "Submit"}
          </Button>
        </div>
      </div>
      <br />

      <div>
        <Table
          dataSource={tableData}
          loading={loading}
          columns={columns}
          handleTableChange={handleTableChange}
          pagination={{
            total: tableTotalSize,
            current: tableCurrentPage,
            pageSize: tablePageSize,
          }}
        />
      </div>
    </div>
  );
};

export default SmDepartments;
